<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col">
          <label for="Label" class="form-label">名前</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="スタッフ名"
            v-model="staff.label"
          />
        </div>
        <div class="col">
          <label for="Label" class="form-label">タイプ</label>
          <bs-select
            :options="staff_type"
            :nullOption="true"
            v-model="staff.type"
          ></bs-select>
        </div>
      </div>
      <h5>所属医院</h5>

      <div class="row mb-3 py-2">
        <div class="col" v-for="clinic in clinic_list" :key="clinic">
          <div class="d-grid gap-2">
            <button
              @click="attachData(clinic.id)"
              :class="' btn ' + dataClass(clinic.id)"
            >
              {{ clinic.label }}
            </button>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';
import axios from 'axios'
import config from '../../../const'

export default {
  name: 'StaffDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      staff: {}
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsCheckBox,
  },
  methods: {
    attachData(target) {
      if (this.dataClassChk(target)) {
        const index = this.staff.relations.findIndex(relation => {
          return relation.clinic_id == target
        })
        const tmp = [...this.staff.relations]
        tmp.splice(index, 1)
        this.staff.relations = tmp
      } else {
        console.log('attachData nashi', target)
        const relation = {
          stat: 0,
          staff_id: this.staff.id,
          clinic_id: target
        }
        this.staff.relations.push(relation)
      }
      this.$forceUpdate()
    },
    async loadClinicList() {
      // console.log('tag');
      // 紐付clinic_id
      const params = this.get_clinic_relation_where
      params['stat'] = [1]
      return this.$store
        .dispatch('fetchBasicLists', { data: params, target: 'clinic' })
        .catch(err => Promise.reject(err))
        .then(() => {})
        .finally(() => {})
    },
    async loadStaffType() {
      // console.log('tag');
      return this.$store
        .dispatch('fetchBasicLists', { data: {}, target: 'staff_type' })
        .catch(err => Promise.reject(err))
        .then(() => {})
        .finally(() => {})
    },
    async loadStaff() {
      const params = {}
      params['id'] = this.targetid
      await axios
        .post(
          config.BASE_API_URL + '/staff/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadStaff', response)
          this.staff =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.staff = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.staff)
      return this.$store
        .dispatch('updateBasic', { data: this.staff, target: 'staff' })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadStaff()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({
      clinic_list: state => state.apidata.clinic,
      staff_type: state => state.apidata.staff_type
    }),
    dataClassChk: function () {
      const staff = this.staff
      return function (clinic_id) {
        if (
          typeof staff === 'object' &&
          typeof staff.relations === 'object' &&
          staff.relations.find(rel => {
            return rel.clinic_id == clinic_id
          })
        ) {
          return true
        }
        return false
      }
    },
    dataClass: function () {
      const dataClassChk = this.dataClassChk
      return function (clinic_id) {
        if (dataClassChk(clinic_id)) {
          return 'btn-primary'
        }
        return 'btn-light btn-outline-secondary'
      }
    }
  },

  async created() {
    await this.loadClinicList()
    await this.loadStaffType()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadStaff()
      this.btnLabel = '更新'
    } else {
      this.staff = {
        id: 0,
        label: '',
        type: 'doctor',
        sort: 0,
        relations: []
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
    // const ret = !Number.isNaN(this.targetid)
    //   ? {...this.$store.getters.getDepartmentById(this.targetid)}
    //   : {};
    // this.department = ret;
  },
  mounted: function () {
    this.fromParentTitle = 'スタッフデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
